import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { Fetch } from "../../../shared/Fetch";
import { useEffect, useRef, useState } from "react";
import { IMassMailInhouseCompanySetting } from "./MassMailInhouseCompanySettingTable";

interface IProps {
    reload: boolean,
    setReload: (reload: boolean) => void,
    toast: any,
}

export const MassMailInhouseCompanySettingForm = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IMassMailInhouseCompanySetting>, loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);
    const [focusIndex, setFocusIndex] = useState<number>(-1);
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("MassMail/getMassMailInhouseCompanySetting", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IMassMailInhouseCompanySetting> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const onsubmit = async () => {
        setLoading(true);
        let isError1: number = 0;
        let isErrorIndex: number = 0;

        const newData: any = tableData.tableData.map((el: IMassMailInhouseCompanySetting, index: number) => {
            const maxEmailsCount: number = Number(el.no_of_email_fresher || "0") + Number(el.no_of_email_midlevel || "0") + Number(el.no_of_email_exprience || "0");

            if (Number(el.max_Mail_Count || "0") < maxEmailsCount) {
                isError1 = 1;
                isErrorIndex = index;
            };

            return {
                id: el.id, max_Mail_Count: el.max_Mail_Count,
                no_Of_Email_Fresher: el.no_of_email_fresher,
                no_Of_Email_MidLevel: el.no_of_email_midlevel,
                no_Of_Email_Exprience: el.no_of_email_exprience,
                no_Of_Months_Fresher: el.no_Of_Months_Fresher,
                no_Of_Months_MidLevel: el.no_Of_Months_MidLevel,
                no_Of_Months_Experienced: el.no_Of_Months_Experienced,
                no_Of_Selectingcount: el.no_Of_Selectingcount
            };
        });

        if (isError1 === 1) {
            props.toast.current.show({ severity: "error", detail: "Can Not Updated Beacuse one of the Max Mail Count is less than No of emails", life: 3000, });
            setFocusIndex(isErrorIndex);
            setLoading(false);
        } else {
            const method = "PUT";
            const message = "Updated Successfully";
            setLoading(true);

            const resp = await Fetch("MassMail/updateMassMailInhouseCompanySetting", method, newData, null, null);
            if (resp) {
                props.toast.current.show({ severity: "success", detail: message, life: 3000, });
                props.setReload(!props.reload);
                setLoading(false);
                setFocusIndex(-1);
            } else setLoading(false);
        }
    }

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const onCellEditComplete = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'max_Mail_Count':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'no_of_email_fresher':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'no_of_email_midlevel':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'no_of_email_exprience':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'no_Of_Months_Fresher':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'no_Of_Months_MidLevel':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'no_Of_Months_Experienced':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'no_Of_Selectingcount':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };


        setTableData(prev => {
            const updatedData = prev.tableData.map((item, index) => {
                if (index === focusIndex) {
                    setFocusIndex(-1);
                }
                if (item.id === rowData.id) {
                    return {
                        ...item, max_Mail_Count: isPositiveInteger(rowData.max_Mail_Count)? Number(rowData.max_Mail_Count): item.max_Mail_Count,
                        no_of_email_fresher: isPositiveInteger(rowData.no_of_email_fresher)? Number(rowData.no_of_email_fresher): item.no_of_email_fresher,
                        no_of_email_midlevel: isPositiveInteger(rowData.no_of_email_midlevel)? Number(rowData.no_of_email_midlevel): item.no_of_email_midlevel,
                        no_of_email_exprience: isPositiveInteger(rowData.no_of_email_exprience)? Number(rowData.no_of_email_exprience): item.no_of_email_exprience,
                        no_Of_Months_Fresher: isPositiveInteger(rowData.no_Of_Months_Fresher)? Number(rowData.no_Of_Months_Fresher): item.no_Of_Months_Fresher,
                        no_Of_Months_MidLevel: isPositiveInteger(rowData.no_Of_Months_MidLevel)? Number(rowData.no_Of_Months_MidLevel): item.no_Of_Months_MidLevel,
                        no_Of_Months_Experienced: isPositiveInteger(rowData.no_Of_Months_Experienced)? Number(rowData.no_Of_Months_Experienced): item.no_Of_Months_Experienced,
                        no_Of_Selectingcount: isPositiveInteger(rowData.no_Of_Selectingcount)? Number(rowData.no_Of_Selectingcount): item.no_Of_Selectingcount
                    };
                }
                return item;
            });
            return { ...prev, tableData: updatedData };
        })
    };

    const cellEditor = (options: ColumnEditorOptions) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };
        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', cursor: "pointer" }} value={options.value} type='number' onChange={(e) => handleChange(e)} />
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);
    console.log(focusIndex);

    return (
        <>
            <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", }}
                size="small" ref={dt} value={tableData.tableData} emptyMessage="No Data found."
                loading={tableData.loading} showGridlines stripedRows responsiveLayout="scroll"
            >
                <Column field="company_Name" header="Company" />
                <Column field="max_Mail_Count" header="Max Email Sending Count" body={(rowData: IMassMailInhouseCompanySetting, options: any) => <p className={(options.rowIndex === focusIndex) ? "glow-loop" : ""} style={{ color: (options.rowIndex === focusIndex) ? "red" : "black" }}>{rowData.max_Mail_Count}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column className="bg-blue-300 font-bold" field="no_Of_Months_Fresher" header="No of Months for Fresher " body={(rowData: IMassMailInhouseCompanySetting) => <p>{rowData.no_Of_Months_Fresher}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column className="bg-green-300 font-bold" field="no_Of_Months_MidLevel" header="No of Months for Mid-level " body={(rowData: IMassMailInhouseCompanySetting) => <p>{rowData.no_Of_Months_MidLevel}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column className="bg-teal-300 font-bold" field="no_Of_Months_Experienced" header="No of Months for Exprience" body={(rowData: IMassMailInhouseCompanySetting) => <p>{rowData.no_Of_Months_Experienced}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column className="bg-blue-200 font-bold" field="no_of_email_fresher" header="No of Email for Fresher " body={(rowData: IMassMailInhouseCompanySetting) => <p>{rowData.no_of_email_fresher}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column  className="bg-green-200 font-bold" field="no_of_email_midlevel" header="No of Email for  Mid-level " body={(rowData: IMassMailInhouseCompanySetting) => <p>{rowData.no_of_email_midlevel}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column  className="bg-teal-200 font-bold" field="no_of_email_exprience" header="No of Email for  Exprience" body={(rowData: IMassMailInhouseCompanySetting) => <p>{rowData.no_of_email_exprience}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="no_Of_Selectingcount" header="Maximum Selecting Count At Once" body={(rowData: IMassMailInhouseCompanySetting) => <p>{rowData.no_Of_Selectingcount}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="updated_By" header="Updated By" />
            </DataTable>
            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                <Button loading={loading} disabled={loading} style={{ width: "100px" }} label="SAVE" type="button" onClick={() => {
                    if (tableData.tableData.length > 0) {
                        onsubmit();
                    }
                }} ></Button>
            </div>
        </>
    );
}